import { useRegion, REGIONS } from "@/context/RegionContext";

export function RegionSwitcher({ className = "" }) {
  const { region, setRegion } = useRegion();
  return (
    <div
      className={`inline-flex items-center rounded-full border border-border bg-secondary p-0.5 ${className}`}
      data-testid="region-switcher"
    >
      {Object.values(REGIONS).map((r) => (
        <button
          key={r.code}
          type="button"
          onClick={(e) => { e.preventDefault(); e.stopPropagation(); setRegion(r.code); }}
          className={`flex items-center gap-1.5 rounded-full px-3 py-1.5 text-xs font-semibold transition-colors ${
            region === r.code ? "bg-white text-primary shadow-sm" : "text-muted-foreground hover:text-foreground"
          }`}
          data-testid={`region-btn-${r.code}`}
          aria-pressed={region === r.code}
        >
          <span className="text-sm leading-none">{r.flag}</span> {r.short}
        </button>
      ))}
    </div>
  );
}
